import { render } from "./OfficeSection.vue?vue&type=template&id=01b954ea&scoped=true"
import script from "./OfficeSection.vue?vue&type=script&lang=js"
export * from "./OfficeSection.vue?vue&type=script&lang=js"

import "./OfficeSection.vue?vue&type=style&index=0&id=01b954ea&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01b954ea"]])

export default __exports__